import { Icon, mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getSourceAppFromUrl } from '../../../../web/utils/statelessUtil';
import { SourceApps, IconNames } from '../../../models/constants/constants';
import { getCommonClassNames, getCommonStyles } from '../styles/commonStyles';
import { getSectionHeaderClassNames, getSectionHeaderStyles } from '../styles/sectionHeaderStyles';
import { IContactUsCurrentTheme } from '../styles/theme.model';
import { BusinessAssistBadge } from './BusinessAsssistBadge';
import { getString } from '../../../../web/utils/stringLoader';

interface ISectionHeaderClassNames {
  title?: string;
  description?: string;
  container?: string;
}

export interface SectionHeaderProps {
  title?: string;
  description?: string;
  isUnifiedPremier?: boolean;
  isUnifiedEnterprisePremier?: boolean;
  isNonUnifiedPremier?: boolean;
  isPremierTenantEnabled?: boolean;
  classNames?: ISectionHeaderClassNames;
  descriptionElement?: React.ReactElement;
  theme: IContactUsCurrentTheme;
  largeFrontPageTitle?: boolean;
  isBATenant?: boolean;
  isBusinessAssistUXEnabled?: boolean;
}

const commonClassNames = getCommonClassNames(getCommonStyles!, {});

export const SectionHeader = (props: SectionHeaderProps) => {
  const sectionHeaderClassNames = getSectionHeaderClassNames(getSectionHeaderStyles, { theme: props.theme, largeFrontPageTitle: props.largeFrontPageTitle });

  const key: string = uuidv4();
  if (!props.title && !props.description) {
    return null;
  }

  let titleClassName = getSourceAppFromUrl(window.location.href) === SourceApps.SurfaceApp || getSourceAppFromUrl(window.location.href) === SourceApps.SurfaceApp2 ? mergeStyles(commonClassNames.ellipsisText, sectionHeaderClassNames.sectionSurfaceAppTitle) : mergeStyles(commonClassNames.ellipsisText, sectionHeaderClassNames.sectionTitle);
  let descriptionClassName = sectionHeaderClassNames.sectionDescription;
  let containerClassName = commonClassNames.headerContainerRow;
  const headerContainerClassName = commonClassNames.flexContainerRow;
  const premierBadgeClassName = sectionHeaderClassNames.premierBadge;
  const premierBadgeIconClassName = sectionHeaderClassNames.premierBadgeIcon;
  const premierBadgeTextClassName = sectionHeaderClassNames.premierBadgeText;
  if (props.classNames) {
    titleClassName = props.classNames.title || titleClassName;
    descriptionClassName = props.classNames.description || descriptionClassName;
    containerClassName = props.classNames.container || containerClassName;
  }

  return (
    <div className={containerClassName} tabIndex={-1}>
      {!!props.isBATenant && props.isBusinessAssistUXEnabled &&(
        <BusinessAssistBadge />
      )}
      <div className={headerContainerClassName}>
        {props.title && <h1 key={`${key}-title`} className={titleClassName} style={{ marginTop: 0 }}>{props.title}</h1>}
        {!!props.isPremierTenantEnabled && (props.isUnifiedPremier ||
          props.isUnifiedEnterprisePremier ||
          props.isNonUnifiedPremier) && (
          <div className={premierBadgeClassName}>
            <Icon
              iconName={IconNames.PremierBadgeIconName}
              className={premierBadgeIconClassName}/>
            <span className={premierBadgeTextClassName}>
              {props.isUnifiedPremier && getString('search_premierBadge_unified')}
              {props.isUnifiedEnterprisePremier && getString('search_premierBadge_unifiedEnterprise')}
              {props.isNonUnifiedPremier && getString('search_premierBadge_nonUnified')}
            </span>
          </div>
        )}
      </div>
      <div className={headerContainerClassName}>
        {!props.descriptionElement && props.description && <div key={`${key}-description`} className={descriptionClassName}>{props.description}</div>}
        {!!props.descriptionElement && props.descriptionElement}
      </div>
    </div>
  );
};
